function trimNotificationTitle(title) {
    const trimDescription = title.split(':')[1]
    const trimPeriod = trimDescription.split('.')[0];
    return trimPeriod;
}
export default trimNotificationTitle;